import { useDispatch } from 'react-redux';
import { generatePath } from 'react-router-dom';
import { SelectedPeriod } from 'commons/src/models/commonTypeScript';
import { fetchSpaces, fetchSpaceSensorData } from '../../../../actions/spaceActions';

export type UseSpaceThresholdModalProps = {
    locationId: string;
    spaceId: string;
    onClose: () => void;
    selectedPeriod: SelectedPeriod;
};

export type UseSpaceThresholdModalReturn = {
    onSaveSuccess: () => void;
    redirectToBuildingThresholds: string;
};

const useSpaceThresholdModal = ({
    locationId,
    spaceId,
    onClose,
    selectedPeriod,
}: UseSpaceThresholdModalProps): UseSpaceThresholdModalReturn => {
    const dispatch = useDispatch();

    const onSaveSuccess = (): void => {
        dispatch(fetchSpaces(locationId));
        dispatch(fetchSpaceSensorData(locationId, spaceId, selectedPeriod));
        onClose();
    };

    const redirectToBuildingThresholds = generatePath('/buildings/:locationId/settings', { locationId });

    return {
        onSaveSuccess,
        redirectToBuildingThresholds,
    };
};

export default useSpaceThresholdModal;
